import {
  usePopoverArrow
} from "../__chunks/UBPCHT5E.js";
import "../__chunks/GM7XQV7F.js";
import "../__chunks/6GS36SYX.js";
import {
  createComponent,
  createElement,
  createHook
} from "../__chunks/5ETIGB6O.js";
import "../__chunks/ASYR66PQ.js";
import "../__chunks/SXC6BPOF.js";
import "../__chunks/4BKCJXBM.js";

// src/menu/menu-arrow.ts
var useMenuArrow = createHook((props) => {
  return usePopoverArrow(props);
});
var MenuArrow = createComponent((props) => {
  const htmlProps = useMenuArrow(props);
  return createElement("div", htmlProps);
});
if (process.env.NODE_ENV !== "production") {
  MenuArrow.displayName = "MenuArrow";
}
export {
  MenuArrow,
  useMenuArrow
};
